<template>
	<div class="support">
		<div style="position: sticky; top:12px; z-index: 200;">
			<Breadcrumbs :items="items" />
		</div>
		<v-container fluid>
			<v-row v-if="alerts.length > 0" no-gutters align="center" class="mt-3 mb-3">
				<v-icon color="primary mr-9" class="mr-4">mdi-information</v-icon>
				<span class="title font-weight-regular primary--text" v-translate>Alerts</span>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12">
					<v-card color="secondary" v-for="alert in alerts" :key="alert.id" class="mb-2">
						<v-card-title class="primary--text text-subtitle-1">
							<div v-html="alert.title"/>
						</v-card-title>
						<v-card-text>
							<div v-html="alert.text"/>
							<v-img
								v-if="alert.image_url"
								:src="alert.image_url"
								height="300"
								contain
							/>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
			<template v-if="questions.length > 0">
				<v-row no-gutters align="center" class="my-4">
					<v-icon color="primary mr-9" class="mr-4">help</v-icon>
					<span class="title font-weight-regular primary--text" v-translate>FAQ</span>
					<v-spacer></v-spacer>
					<v-btn icon @click="clickSearchQuestion">
						<v-icon color="primary">mdi-magnify</v-icon>
					</v-btn>
					<v-text-field
						v-if="showSearchQuestion"
            v-model="searchQuestion"
						ref="searchQuestionField"
						placeholder="Search"
            outlined
            class="px-2 shrink"
            dense
            hide-details
            style="width: 300px"
          ></v-text-field>
				</v-row>
				<p v-if="filteredQuestions.length == 0" class="font-weight-thin ml-2" v-translate>No questions found.</p>
				<v-expansion-panels v-else class="mb-10">
					<v-expansion-panel
						v-for="question in filteredQuestions"
						:key="question.id"
					>
						<v-expansion-panel-header>
							<div v-html="question.question" class="question-header text-subtitle-1 font-weight-bold"/>
							<!-- <template v-slot:actions>
								<v-chip>{{question.topic.name}}</v-chip>
							</template> -->
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<div v-html="question.answer"/>
							<v-img
								v-if="question.image_url"
								:src="question.image_url"
								height="300"
								contain
							/>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</template>
			<v-form ref="form" v-model="validForm" class="mt-10">
				<v-row no-gutters justify="center" class="px-2">
					<template v-if="!submited">
						<v-col cols="12" md="12">
							<v-textarea
								outlined
								:label="$gettext('Question/Problem')"
								placeholder=" "
								v-model="question"
								:rules="required"
							></v-textarea>
						</v-col>
						<v-col cols="12" md="12">
							<v-btn color="primary" class="ml-2 float-right" :loading="submiting" @click="submitQuestion">
								<translate>Submit</translate>
							</v-btn>
						</v-col>
					</template>
					<v-alert v-else color="alert" type="success" class="mt-3">
						<translate>Thank you! Your message was submitted. We will try to respond to your email as soon as possible.</translate>
					</v-alert>
				</v-row>
			</v-form>
		</v-container>
	</div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {
	name: "Support",
	components: {
		Breadcrumbs
	},
	data: () => ({
		submited: false,
		submiting: false,
		validForm: false,
		question: null,
		required: [],
		alerts: [],
		questions: [],
		showSearchQuestion: false,
		searchQuestion: ""
	}),
	methods: {
		validate() {
			this.required = [q => !!q || this.$gettext("Required")];
			return this.$refs.form.validate();
		},
		submitQuestion() {
			if (this.validate()) {
				this.submiting = true;
				const formData = new FormData();
				formData.append("message", this.question);
				axios
					.post("/support", formData)
					.then(response => {
						console.log(response.data);
						if (response.status === 200) {
							if (response.data.result === "ok") {
								this.submited = true;
							}
						}
						this.submiting = false;
					})
					.catch(error => {
						console.log(error);
						this.submiting = false;
					});
			}
		},
		clickSearchQuestion() {
			this.showSearchQuestion = !this.showSearchQuestion;
			if(this.showSearchQuestion) setTimeout(() => {this.$refs.searchQuestionField.focus();});
			else this.searchQuestion = "";
		}
	},
	computed: {
		items() {
			return [
				{
					text: this.$gettext("Support"),
					disabled: false,
					link: true,
					to: { name: "support" }
				}
			];
		},
		filteredQuestions() {
			if(this.searchQuestion == "") return this.questions;
			else return this.questions.filter(q => {
				if (q.topic.name.toLowerCase().includes(this.searchQuestion.toLowerCase())) return true;
				else {
					var el = document.createElement( 'html' );
					el.innerHTML = q.question;
					var text = el.getElementsByTagName( 'p' );
					text = text[0].textContent;
					if (text.toLowerCase().includes(this.searchQuestion.toLowerCase())) return true;
				}
				return false;
			});
		}
	},
	created() {
		axios
			.get("/support")
			.then(response => {
        console.log(response.data);
				if (response.status === 200) {
					this.alerts = response.data.alerts;
					this.questions = response.data.questions;
					this.loading = false;
				}
			})
			.catch(error => console.log(error));
	}
};
</script>

<style scoped>
>>> .question-header p {
	margin-bottom: 0px
}
</style>